var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbicacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136.418,
    height: 151.39,
    viewBox: "0 0 136.418 151.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:none;}.b{stroke:#7e8082;stroke-linecap:round;stroke-width:2px;}.d{fill:#fcbf00;}.e{fill:#d1d1d1;}.f{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 136.418,
    height: 151.39,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7136 -99)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, -7136, 99)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.995,0H112.423c5.566,0,5.995.511,5.995,6.177V127.213c0,5.667-.429,6.177-5.995,6.177H5.995C.429,133.39,0,132.88,0,127.213V6.177C0,.511.429,0,5.995,0Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 42.489,
    transform: "translate(-7108.804 176.54)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 82.618,
    transform: "translate(-7108.804 212.75)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 23.552,
    transform: "translate(-7049.738 126.132)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 42.489,
    transform: "translate(-7108.804 188.343)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 23.552,
    transform: "translate(-7049.738 137.934)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 42.489,
    transform: "translate(-7108.804 200.145)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7109.583 119.686)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H45.314V45.314H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M18.217,2A13.207,13.207,0,0,0,5,15.217c0,9.912,13.217,24.545,13.217,24.545S31.433,25.129,31.433,15.217A13.207,13.207,0,0,0,18.217,2Zm0,17.937a4.72,4.72,0,1,1,4.72-4.72A4.722,4.722,0,0,1,18.217,19.937Z",
    transform: "translate(4.44 1.776)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 8,
    cy: 1,
    rx: 8,
    ry: 1,
    transform: "translate(-7095.583 162)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbicacion);
export default __webpack_public_path__ + "static/media/ubicacion.06907978732e0990905fe23edf69aebe.svg";
export { ForwardRef as ReactComponent };